import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import routing from './change-password.routes';
import api from '../../../components/api-service';
import util from '../../../components/util/util.module';
import emailService, { EmailService } from '../../../components/email-service';

import 'angular-translate';
import feconClientBundle from '@infocert/fecon-client-bundle';
const translateModule = 'pascalprecht.translate';

import vcRecaptcha from 'angular-recaptcha';

export class ChangePasswordController {

    constructor(notifier, $state, $log, LmrcApiService, EmailService) {
        'ngInject';
        this._logger = $log.getInstance('ChangePasswordController');
        this.notifier = notifier;
        this._$state = $state;
        this._lmrcApiService = LmrcApiService;
        this.initLoading = false;
        this.loading = false;
        this._emailService = EmailService;
        this.accessType = null;

    }

    $onInit() {
        this._logger.debug("$onInit");
        this.initLoading = false;
        this.username = this._emailService.getUsername();
        this.emailUser = this._emailService.getEmailUser();
        this.emailDomain = this._emailService.getEmailDomain();
        this.accessType = this._emailService.getAccessType();
    }

    resetError() {
        this.errorMessage = null;
    }

    passwordIsValid() {
        this.noUserID = false;
        this.minChar = false;
        this.capLetters = false;
        this.numbers = false;
        this.symbol = false;
        this.notwo = false;
        if (this.password) {
            // noUserID = !this.password.includes($scope.inputLogin);
            this.noUserID = true;
            this.minChar = this.password.length >= 8;
            this.capLetters = this.password.match(/[a-z]/) && this.password.match(/[A-Z]/);
            this.numbers = this.password.match(/\d+/);
            this.symbol = this.password.match(/[!@#$%£^&*(),.?":{}|<>/]/);
            this.notwo = this.password.match(/^(?:(.)(?!\1{2}))*$/);
        }
        this._logger.debug("password validation", {
            'noUserID': this.noUserID,
            'minChar': this.minChar,
            'capLetters': this.capLetters,
            'numbers': this.numbers,
            'symbol': this.symbol,
            'notwo': this.notwo,
        })
        const passwordIsValid = (this.password && this.noUserID && this.minChar && this.capLetters && this.numbers && this.symbol && this.notwo);
        this._logger.debug("password is valid?", passwordIsValid);
        return passwordIsValid;
    }
    passwordsAreTheSame() {
        const passwordEqual = this.password === this.passwordConfirm;
        this._logger.debug("password are equal?", passwordEqual);
        return passwordEqual;
    }

    changePassword(formValid) {
        if (formValid) {
            this.loading = true;
            this._logger.debug("changePassword: inputPassword", this.password);
            this._logger.debug("changePassword: changing password...")
            this._lmrcApiService.changePassword(this.password).then(() => {
                this.loading = false;
                this._logger.debug("changePassword: ok, go to external.success");
                this._$state.go("external.success");
            }, (err) => {
                this.loading = false;
                this._logger.debug("changePassword: failed", err);
                this._logger.debug("changePassword: data code ", err.data.code);
                if (err.data.code === 103) {
                    this.errorMessage = 'Password non valida. Si prega di riprovare';
                } else {
                    this.errorMessage = 'Si &egrave; verificato un errore. Si prega di riprovare';
                }
            });
        }
    }


}

export default angular.module('lmrcApp.change-password', [
        uiRouter,

        translateModule,

        feconClientBundle,
        vcRecaptcha,
        util,
        api,
        emailService
    ])
    .config(routing)
    .component('changePassword', {
        template: require('./change-password.html'),
        controller: ChangePasswordController
    })
    .name;


// WEBPACK FOOTER //
// ./client/app/features/change-password/index.js